import { render, staticRenderFns } from "./admin_registrations.vue?vue&type=template&id=01c9890f&"
import script from "./admin_registrations.vue?vue&type=script&lang=js&"
export * from "./admin_registrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01c9890f')) {
      api.createRecord('01c9890f', component.options)
    } else {
      api.reload('01c9890f', component.options)
    }
    module.hot.accept("./admin_registrations.vue?vue&type=template&id=01c9890f&", function () {
      api.rerender('01c9890f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/administration/admin_registrations.vue"
export default component.exports